import React, { Component } from 'react';
import CertRequestModel from "../../models/certrequest";
import  PanelLayout  from "../layout/panel-layout";

import BSelectInput from "../../helpers/bselect-input";
import SimpleReactValidator from 'simple-react-validator';

import BDateInput from '../../helpers/bdate-input'

import PatientPartial from "../partials/patient";

import moment from 'moment-jalaali';
import Select from 'react-select';

import  uuid from "uuid/v1";
import { userService } from "../../services";
const GenderList = [
    { label: "مرد", value: 1 },
    { label: "زن", value: 2 },
    { label: "نامشخص", value: 3 }

  ];

const createCertReferenceOption = (label) => ({
    label,
    value: uuid(),
});
    



class CertRequest extends React.Component {
    
    
    constructor(props) {
        super(props);
        this.state = { 
           _model:new CertRequestModel(this.refs),
            patient:null,
           certTypeGroupList:null,
           certReferenceList:null,           
           CertificationTypeGroupId:null,
           certTypeList:null,
           selectedcertTypeList:null,
           _CertificationTypeId:null,
           PhysicianId:null,
           physicianList:null,

          
        };
       
        this.handleTextChange = this.handleTextChange.bind(this);
        this.updateCertTypeGroupSelect =this.updateCertTypeGroupSelect.bind(this);
        this.updateCertRefSelect =this.updateCertRefSelect.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.getData = this.getData.bind(this);
        this.handleClick= this.handleClick.bind(this);
        this.refreshModel = this.refreshModel.bind(this);
        this.handleCertRefCreate=this.handleCertRefCreate.bind(this);
        this.updateCertTypeGroupSelect=this.updateCertTypeGroupSelect.bind(this);
        this.updateCertTypeSelect=this.updateCertTypeSelect.bind(this);
        this.updatePhysicianSelect=this.updatePhysicianSelect.bind(this);
        
        SimpleReactValidator.addLocale('fa', {
            required: 'الزامی',
            integer: 'الزامی'
            
          });

          this.validator = new SimpleReactValidator({
            locale: 'fa'
            });

    
    }

    

    updateCertTypeGroupSelect(item) {
        
        let __model = new CertRequestModel(this.refs);  
        __model.CertificationTypeGroupId=item.value;
       // console.log(__model);

        this.setState({

            _model:__model

        });
       
    }
    updateCertRefSelect(item) {
        
        let __model = new CertRequestModel(this.refs);  
        __model.CertificationReferenceId=item.value;
        
        console.log('*ITEM*',item);

        this.setState({

            _model:__model

        });
       
    }

    handleTextChange(event) {
        this.refreshModel();
    }

    handleDateChange(event) {
      
        this.refreshModel();
    }

    componentWillReceiveProps(newProps)
    {
      
        const {physicianList,certReferenceList,certTypeGroupList,certTypeList,model}=newProps;
        
        
        if(physicianList && this.state.physicianList ==null)
        {
            this.setState({

                physicianList:physicianList,    
            });
        }

        if(certTypeGroupList && this.state.certTypeGroupList ==null)
        {
            this.setState({

                certTypeGroupList:certTypeGroupList,    
            });
        }
        if(certTypeList && this.state.certTypeList ==null)
        {
            this.setState({

                certTypeList:certTypeList.filter(x=>x.boolvalue2==false),    
            });
        }
        
        if(model)
        {
            this.setState({

                patient:model,    
            });
        }
       
       
        if(certReferenceList )
        {
            
            this.setState({

                certReferenceList:certReferenceList,    
            });
        }
      
    }
    updateCertTypeGroupSelect(item) {

        
        this.setState({
            CertificationTypeGroupId:item && this.state.certTypeGroupList && this.state.certTypeGroupList.find(p=>p.value===item.value),
            selectedcertTypeList: this.state.certTypeList!=null ? this.state.certTypeList.filter(p=>p.parentId===item.value):[],
            _CertificationTypeId : this.state.certTypeList!=null ? this.state.certTypeList.filter(p=>p.parentId===item.value && p.boolvalue1==true):[],
            //CertificationTypeId:this.state.CertificationTypeGroupId && this.state.certTypeList!=null ? this.state.certTypeList.filter(p=>p.parentId===item.value)[0]:[]
        });

       
        console.log('bb1',this.state._CertificationTypeId);

        this.forceUpdate();

        
        this.refreshModel();
       // console.log('ss',this.state.selectedcertTypeList)
       
       
       
    }

    updatePhysicianSelect(item) {
        this.setState({
            PhysicianId:item && this.state.physicianList && this.state.physicianList.find(p=>p.value===item.value),
          
        });
       
       
       
       
    }

    updateCertTypeSelect(item) {
        this.setState({
            _CertificationTypeId:item && this.state.certTypeList && this.state.certTypeList.find(p=>p.value===item.value),           
        });
        this.refreshModel();
        console.log('CertificationTypeId',this.state._CertificationTypeId)
      
    }


    refreshModel () {
        let __model = new CertRequestModel(this.refs);  
        this.setState({

            _model:__model

        });

      
    }
    getData() {
        let model = new CertRequestModel(this.refs);
        return model;
    }
   
    handleClick = (e) => {
       
        if (this.validator.allValid()) {
            
            this.props.submitHandler(e);

        } else {
            this.validator.showMessages();
           
            this.forceUpdate();
        }
    };

    handleCertRefCreate = (inputValue) => {
       
        const { certReferenceList } = this.state;
        const newOption = createCertReferenceOption(inputValue);
        let __model = new CertRequestModel(this.refs);  
        
        __model.CertificationReferenceId=newOption.value;
        
        let newCertRef ={
            id: newOption.value,
            title: newOption.label
        };

        console.log('newCertRef',newCertRef);

        this.props.CreateCertRefHandler(newCertRef);

        let certList=[...certReferenceList, newOption];
        //console.log('certReferenceLis1',certList);
        
        this.setState({   
            certReferenceList: certList, 
            _model:__model          
        });

        window.location.reload();

        //console.log('certReferenceLis2',this.state.certReferenceList);
    };

    render() { 
        //const {model} = this.props;

        
        const {physicianList,_model,patient,certReferenceList,certTypeGroupList,certTypeList,CertificationTypeGroupId,selectedcertTypeList,_CertificationTypeId}= this.state;
        const {loading,error} = this.props;
        const model=_model;   
        let certTypeId= null;

        if(_CertificationTypeId && _CertificationTypeId.constructor === Array && _CertificationTypeId.length >0)
        {
            certTypeId = _CertificationTypeId[0].value;
        }
        if(_CertificationTypeId && _CertificationTypeId.constructor != Array)
        {
            certTypeId = _CertificationTypeId.value;
        }
        console.log('certTypeId',certTypeId);
        console.log('_CertificationTypeId',_CertificationTypeId);
        return ( 

        <PanelLayout title={"درخواست گواهی"}>

            <div className="panel-body custom">

           

            <PatientPartial patient={patient}></PatientPartial>
                
            
            <div class="panel panel-default">
                <div class="panel-heading">اطلاعات گواهی</div>
                <div class="panel-body">
                    <form autoComplete="off" ref={c => { this.form = c }}>        
                    <div >
                        <input name="PatientId" type="hidden" ref="PatientId" value={patient && patient.Id}></input>
                        <input type="hidden"  value={certTypeId} name="CertificationTypeId" ref="CertificationTypeId"></input>
                        {error &&
                            <div class="alert alert-danger">
                               {error}
                            </div>
                        }
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>
                                    گروه گواهی
                                </label>
                               
                                { certTypeGroupList &&
                                    <div>


                                  

                                         <BSelectInput 
                                            
                                            onChange={this.refreshModel}
                                            value ={this.state.CertificationTypGroupId && this.state.CertificationTypGroupId.value }                                   
                                            options={certTypeGroupList && certTypeGroupList.constructor === Array ? certTypeGroupList : []}
                                            onChangeHandler={this.updateCertTypeGroupSelect}
                                            clearable={false}
                                            normal={true}
                                            ref="CertificationTypeGroupId"
                                            name="CertificationTypeGroupId"
                                                
                                        /> 
                                        
                                    </div>
                                   
                                }
                                
                            </div>
                            <div class="form-group">
                            <label class="control-label" for="email">نوع گواهی</label>
                              
                                <Select 
                                    
                                    onChange={this.updateCertTypeSelect}
                                    value ={_CertificationTypeId }                                   
                                    options={selectedcertTypeList && selectedcertTypeList.constructor === Array ? selectedcertTypeList : []}
                                   
                                    clearable={true}
                                    placeholder="انتخاب کنید"
                                    noResultsText="نتیجه‌ای یافت نشد"
                                   
                                    
                                    
                                />
                           
                        </div>
                            
                            <div className="form-group">
                                <label>
                                    مرجع
                                </label>
                                {  certReferenceList &&

                                

                                    <BSelectInput 
                                        ref="CertificationReferenceId"
                                        onChange={this.refreshModel}
                                    // value ={model && certTypeGroupList.find(p=>p.value=== model.IdentityCityId) }                                   
                                        options={certReferenceList && certReferenceList.constructor === Array ? certReferenceList : []}
                                        onChangeHandler={this.updateCertRefSelect}
                                        onCreateOption={this.handleCertRefCreate}
                                        clearable={false}
                                        creatable={true}
                                        name="CertificationReferenceId"
                                    />
                                }
                            </div>
                           
                            
                           
                            
                        </div>
                        <div className="col-md-6">
                        <div className="form-group">
                                <label>
                                    تاریخ صدور
                                </label>
                                <BDateInput
                                
                                    className="form-control"
                                    ref="RequestDateInPersian" 
                                    value={moment(model.RequestDateInPersian).isValid()?  model.RequestDateInPersian:moment() } 
                                    onChange={this.handleDateChange}
                                
                                />
                            </div>
                            <div className="form-group">
                                <label>
                                    تاریخ نامه
                                </label>
                                <BDateInput
                                
                                    className="form-control"
                                    ref="ReferenceLetterDate" 
                                    value={moment(model.ReferenceLetterDate).isValid()?  model.ReferenceLetterDate:moment() } 
                                    onChange={this.handleDateChange}
                                
                                />
                            </div>
                            <div className="form-group">
                                <label>
                                   شماره نامه درخواست
                                </label>
                                <input  className="form-control" onChange={this.handleTextChange} value={model && model.ReferenceLetterNo } ref="ReferenceLetterNo" name="ReferenceLetterNo"  type="text" />
                              
                            </div>
                            { userService.hasRoles(["Secretary"]) && physicianList &&
                                <div className="form-group">
                                    <label>
                                        پزشک
                                    </label>
                                
                                
                                        <div>
                                            <BSelectInput 
                                                
                                                onChange={this.refreshModel}
                                                value ={this.state.PhysicianId && this.state.PhysicianId }                                   
                                                options={physicianList && physicianList.constructor === Array ? physicianList : []}
                                                onChangeHandler={this.updatePhysicianSelect}
                                                clearable={false}
                                                normal={true}
                                                ref="PhysicianIds"
                                                name="PhysicianIds"
                                                    
                                            />
                                            <input type="hidden" ref="PhysicianId" name="PhysicianId" value={this.state.PhysicianId && this.state.PhysicianId.value}></input>
                                            {this.validator.message('PhysicianId',this.state.PhysicianId && this.state.PhysicianId.value, 'required')}
                                        </div>
                                    
                                    
                                </div>
                            }

                        </div>
                       
                    </div>
                    </form>
                
                
                </div>
                
            </div>
               

            <div className="panel panel-default">
               
               <div className="toolbox">

               <button type="button" disabled ={loading } className="btn btn-primary btn-sm" onClick={this.handleClick} ><i className="fa fa-save"></i>   ثبت و ادامه

{ loading &&
    <i className="fa fa-spinner fa-spin"></i>
}

</button>

               
               </div>
           </div>
    
               
          
            </div>
        </PanelLayout>





        );
    }
}

 
export default CertRequest;